/*
 * Basic Layout for wrapping the sortable list of comments
 */

define([
  "marionette",
  "modules/shared/surveyComments/template/surveyCommentsTemplate.html",
], function (Marionette, SurveyCommentsTemplate) {
  var SurveyCommentsView = {};

  SurveyCommentsView.surveyCommentsView = Marionette.Layout.extend({
    template: SurveyCommentsTemplate,
    regions: {
      list: "#commentsList",
    },
  });

  return SurveyCommentsView;
});
